import React, { Component } from 'react';
import moment from 'moment';

class EmployeeTimer extends Component {
	state = {
		hours: '00',
		minutes: '00',
		seconds: '00'
	};

	componentDidMount() {
		console.log('EmployeeTimer mounted with startTime:', this.props.startTime);
		this.interval = setInterval(() => {
			this.updateTimer();
		}, 1000);
		this.updateTimer();
	}

	componentWillUnmount() {
		if (this.interval) {
			clearInterval(this.interval);
		}
	}

	updateTimer = () => {
		const { startTime } = this.props;
		if (!startTime) {
			console.log('No startTime provided to EmployeeTimer');
			return;
		}

		const start = moment.utc(startTime);
		const now = moment();
		const diff = moment.duration(now.diff(start));

		const hours = Math.floor(diff.asHours()).toString().padStart(2, '0');
		const minutes = (diff.minutes()).toString().padStart(2, '0');
		const seconds = (diff.seconds()).toString().padStart(2, '0');

		this.setState({ hours, minutes, seconds });
	};

	render() {
		const { hours, minutes, seconds } = this.state;

		return (
			<div className="timer">
				<div className="timer-item">
					<div className="timer-value">{hours}</div>
					<div className="timer-key">h</div>
				</div>
				<div className="timer-item">
					<div className="timer-value">{minutes}</div>
					<div className="timer-key">m</div>
				</div>
				<div className="timer-item">
					<div className="timer-value">{seconds}</div>
					<div className="timer-key">s</div>
				</div>
			</div>
		);
	}
}

export default EmployeeTimer; 